<script>
import LegoQuill from "@/components/Lego/LegoQuill.vue";
import LegoDropzone from "@/components/Lego/LegoDropzone.vue";
import { avatarColors } from "../../utils/avatarColors";

export default {
  components: {
    LegoQuill,
    LegoDropzone,
  },
  data() {
    return {
      commentHtml: "",
      loaderFile: false,
      collapsed: false,
    };
  },
  computed: {
    pathNewAttachmentFile() {
      return `Lego/Tablero/${this.$route.params.boardId}/card/${this.cardId}/comments`;
    },
    userLoggedIn() {
      return this.$store.getters.userLoggedIn;
    },
    cardId() {
      return this.$route.params.cardId;
    },
    paginatedComments() {
      return this.$store.state.lego.card.paginatedComments;
    },
    loadingMoreComments() {
      return this.$store.state.lego.isLoadingComments;
    },
  },
  mounted() {
    this.$nextTick(() => {
      const container = this.$refs.commentsContainer;
      if (container) {
        container.addEventListener("scroll", this.handleScrollComments);
      }
    });
  },
  beforeDestroy() {
    const container = this.$refs.commentsContainer;
    if (container) {
      container.removeEventListener("scroll", this.handleScrollComments);
    }
  },
  methods: {
    async loadMoreComments() {
      await this.$store.dispatch("lego/loadMoreComments", {
        cardId: this.cardId,
      });
    },
    getAvatarColor(idx) {
      return avatarColors(idx);
    },
    cancelComentario(blurQuill) {
      this.commentHtml = "";
      blurQuill();
    },
    keydownHandler(ev) {
      if (ev.ctrlKey && ev.keyCode == 13) {
        this.sendComment();
      }
    },
    autoLinkHtml(html) {
      const urlRegex = /\b((https?:\/\/|www\.)[^\s<>"']+)/gi;

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const walker = document.createTreeWalker(
        doc.body,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );

      while (walker.nextNode()) {
        const node = walker.currentNode;

        // Ignorar si está dentro de un <a>
        if (node.parentElement && node.parentElement.tagName === "A") continue;

        const replacedText = node.nodeValue.replace(urlRegex, (match) => {
          const href = match.startsWith("http") ? match : `https://${match}`;
          return `<a href="${href}" target="_blank" rel="noopener noreferrer">${match}</a>`;
        });

        if (replacedText !== node.nodeValue) {
          const span = document.createElement("span");
          span.innerHTML = replacedText;
          node.parentNode.replaceChild(span, node);
        }
      }

      return doc.body.innerHTML;
    },
    sanitizeHtml(html) {
      // console.log("html", html);

      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      // Elimina todos los estilos inline y <span>
      doc.querySelectorAll("*").forEach((el) => {
        el.removeAttribute("style");
        if (el.tagName === "SPAN") {
          const parent = el.parentNode;
          while (el.firstChild) parent.insertBefore(el.firstChild, el);
          parent.removeChild(el);
        }
      });

      return doc.body.innerHTML;
    },
    sendComment() {
      const cleanHtml = this.sanitizeHtml(this.commentHtml);

      const comment = {
        legoCardId: this.cardId,
        html: this.autoLinkHtml(cleanHtml),
        createdById: this.userLoggedIn.id,
      };

      // console.log("comment", comment);

      this.$store.dispatch("lego/addCommentInCard", comment);

      // this.comments.push(comment)
      this.commentHtml = "";
    },
    tiempoTranscurrido(date) {
      return this.$store.getters.tiempoTranscurrido(date, true);
    },
    async insertImageAsLink(self) {
      this.loaderFile = true;
      await self.saveInSmarter();

      if (self.isSaveFile) {
        let aImgHtml;
        if (self.file.type.includes("image")) {
          aImgHtml = `<div>
            <a target="_blank" href="${self.pathAfterSaveInRemote}" >
            <img width="200" src="${self.pathAfterSaveInRemote}" alt="${
            self.fileName + self.dotExtension
          }" />
            </a>
          </div>`;
        } else {
          aImgHtml = `<p>
            <a target="_blank" href="${self.pathAfterSaveInRemote}" >
            ${self.fileName + self.dotExtension}
            </a>
          </p>`;
        }
        console.log("aImgHtml", aImgHtml);

        this.commentHtml += aImgHtml;
      } else {
        console.log("error");
      }

      this.loaderFile = false;
    },
    handleScrollComments() {
      const container = this.$refs.commentsContainer;
      if (!container) return;
      const threshold = 100; // px antes del final
      const { scrollTop, scrollHeight, clientHeight } = container;
      if (
        scrollTop + clientHeight >= scrollHeight - threshold &&
        this.paginatedComments.hasMore &&
        !this.loadingMoreComments
      ) {
        this.loadMoreComments();
      }
    },
  },
};
</script>

<template>
  <div>
    <div
      class="section-header item-display header"
      @click="collapsed = !collapsed"
    >
      <div>
        <span>
          <i class="fa-regular fa-comment-dots title-icon"></i>
        </span>
      </div>
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          width: 100%;
        "
      >
        <span class="title-section">
          Comentarios ({{ paginatedComments?.total || 0 }})
        </span>
        <i
          :class="[
            'fas',
            collapsed ? 'fa-chevron-down' : 'fa-chevron-up',
            'chevron-icon',
          ]"
        ></i>
      </div>
    </div>
    <transition name="fade">
      <div v-show="!collapsed">
        <article class="item-display">
          <div class="in-right">
            <LegoQuill
              class="quill-container"
              v-model="commentHtml"
              @ctrlEnter="sendComment"
              @esc="cancelComentario"
              :placeholder="'Tu comentario\nEnviar: ctrl + enter'"
            >
              <template #header>
                <div class="inject-header">
                  <!-- En el componente debemos meter un calback solo cuando se suben los archivos -->
                  <LegoDropzone
                    hiddenFooter
                    @fileInCache="insertImageAsLink"
                    :remotePath="pathNewAttachmentFile"
                  >
                    <template #dropzone="{ triggerFileInput }">
                      <div
                        class="dropzone quill-dropzone"
                        @click="triggerFileInput"
                      >
                        <!-- documentos -->
                        <i v-if="!loaderFile" class="fas fa-file-upload"></i>
                        <i v-else class="fa fa-spinner fa-spin"></i>
                      </div>
                    </template>
                  </LegoDropzone>
                </div>
              </template>

              <template #controls="{ blurQuill }">
                <vs-button @click="sendComment">Enviar</vs-button>
                <vs-button danger @click="cancelComentario(blurQuill)"
                  >Cancelar</vs-button
                >
              </template>
            </LegoQuill>
          </div>
        </article>

        <article
          ref="commentsContainer"
          class="container-comments custom-scrollbar"
        >
          <div
            v-for="comment in paginatedComments?.items || []"
            :key="comment.id"
            class="item-display comment-content"
          >
            <div>
              <vs-avatar
                size="35"
                class="lego-vs-avatar"
                :color="getAvatarColor(comment.createdById)"
              >
                <template #text>
                  {{ comment.createdBy.nombres }}
                  {{ comment.createdBy.apellidos }}
                </template>
              </vs-avatar>
            </div>
            <div class="comment-body--creator">
              <span class="font-weight-bold ml-2">
                {{ comment.createdBy.nombres }}
                {{ comment.createdBy.apellidos }}
              </span>
              <span
                v-b-tooltip
                :title="
                  $moment(comment.createdAt).format('DD MMM, YYYY hh:mm a')
                "
              >
                {{ comment.createdAt | moment("from", "now") }}
              </span>
              <span v-if="comment.isValidate" v-b-tooltip title="Validado">
                <i class="fa-solid fa-hands"></i>
              </span>
            </div>
            <div class="comment-body in-right">
              <div class="commentHtml" v-html="comment.html"></div>
            </div>
          </div>
        </article>

        <div v-if="loadingMoreComments" class="text-center p-2">
          <p>Cargando comentarios...</p>
        </div>

        <div v-if="paginatedComments?.items.length" class="load-more-comments">
          <div
            class="info-comments"
            v-b-tooltip.hover
            :title="`${paginatedComments?.items.length} de ${paginatedComments?.total} comentarios`"
          >
            {{ paginatedComments?.items.length }}/{{ paginatedComments?.total }}
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.load-more-comments {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 1rem 0;
  width: 100%;
}

.info-comments {
  align-self: end;
  width: fit-content;
}

.btn-more-comments {
  display: inline-block;
  max-height: 50px;
  min-width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  padding: 0.5rem 0;

  &:hover span {
    text-decoration: underline;
  }
}

.quill-container {
  position: relative;
}

.inject-header {
  position: absolute;
  right: 0;
  top: 0;
  padding: 0.5rem;
}

.quill-dropzone {
  z-index: 1;
  height: 25px;
  width: 25px;
}

.header {
  margin: 1.3rem 0 0.8rem 0;
}

.item-display {
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 0.5rem;
}

.in-right {
  grid-column-start: 2;
  grid-column-end: none;
}

.title-section,
.title-icon {
  font-size: 1.1rem;
  display: flex;
  gap: 0.5rem;
}

.title-icon {
  font-size: 1.2rem;
}

.controls {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.8rem;
}

.controls > * {
  margin: 0;
}

.comment-body--creator {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.comment-content {
  margin: 1rem 0;
}

.container-comments {
  overflow-y: auto;
  max-height: 500px;
}

.comment-body {
  border-radius: 0 6px 6px 6px;
  background-color: var(--lego-dbg);
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  margin-right: 0.5rem;

  .dark & {
    background-color: var(--lego-bg);
  }
}

.comment-date {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.tc-enter-active,
.tc-leave-active {
  transition: all 0.5s ease-out;
  height: 28px;
}

.tc-enter,
.tc-leave-to {
  opacity: 0;
  visibility: hidden;
  height: 0;
}

.commentHtml :deep(p) {
  margin: 0.2rem;
}

.commentHtml :deep(ol),
.commentHtml :deep(ul) {
  margin: 0.2rem 0;
  padding-left: 1rem !important;
}

.commentHtml :deep(ul li) {
  list-style: circle;
}

.commentHtml :deep(ol li) {
  /* le pone un decorador a cada elemento en la lista */
  list-style: number;
}
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.chevron-icon {
  margin-left: 0.5rem;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
